import React, { useState, useEffect } from "react";
import { Card, Tooltip, Button, Space, Divider } from "antd";
import { Link, useRouteMatch } from "react-router-dom";
import ConfidentialJobIcon from "../../../../assets/icons/confidential-job.png";
import styled from "styled-components";

interface Props {
  job?: any;
  trimText?: boolean;
}

const JobCard: React.FC<Props> = ({ job, trimText }) => {
  let { url } = useRouteMatch();
  const [imgURL, setImgURL] = useState(
    job.isConfidential ? ConfidentialJobIcon : job.company.logoUrl
  );

  useEffect(() => {}, []);
  return (
    <>
      {job && (
        <JobBannerContainer>
          <OverLayImageBackground banner={job?.banner} className="text-center">
            <div
              className="directory-overlay"
              style={{ height: 300, borderRadius: "16px" }}
            >
              <BannerContent>
                <CompanyLogo>
                  <img
                    src={imgURL}
                    className="img-thumbnail rounded-circle"
                    style={{
                      padding: job.isConfidential ? 0 : undefined,
                      width: "70px",
                      height: "70px",
                      objectFit: "cover",
                      backgroundColor: "white",
                    }}
                    alt="company logo"
                  />
                </CompanyLogo>
                <JobInfo>
                  <JobTitle>{job.title}</JobTitle>
                  <Link to={`/companies/view/${job.company._id}`}>
                    <CompanyName>
                      {job.isConfidential
                        ? "The hiring company"
                        : job.company.name}
                    </CompanyName>
                  </Link>
                </JobInfo>
              </BannerContent>
            </div>
          </OverLayImageBackground>
        </JobBannerContainer>
      )}
      <div className="directory-content">
        {/* <div className="set-job-title">
          <img
            src={imgURL}
            className="img-thumbnail rounded-circle set-job-detail-image"
            style={{ padding: job.isConfidential && 0 }}
            alt="job logo"
          />
          <div> 
            <h1 className="font-16 mt-3 text-primary">{job.title}</h1>

            <Link to={`/companies/view/${job.company._id}`}>
              <h4>
                {job.isConfidential ? "The hiring company" : job.company.name}
              </h4>
            </Link>
          </div>
        </div>*/}
        <Divider
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.25)",
            margin: "16px",
            width: "calc(100% - 32px)",
            minWidth: "calc(100% - 32px)",
          }}
        />
        <p
          style={{ padding: 16, color: "#495057" }}
          className="font-14"
          dangerouslySetInnerHTML={{ __html: job.description }}
        ></p>
      </div>
    </>
  );
};

const JobBannerContainer = styled.div`
  margin-bottom: 20px;
`;

const BannerContent = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 20px;
  height: 100%;
  position: relative;
  z-index: 2;
`;

const CompanyLogo = styled.div`
  margin-right: 20px;
  flex-shrink: 0;
`;

const JobInfo = styled.div`
  color: white;
  text-align: left;
`;

const JobTitle = styled.h1`
  color: white !important;
  font-size: 24px !important;
  font-weight: 600 !important;
  margin: 0 0 8px 0 !important;
  line-height: 1.2;
`;

const CompanyName = styled.h2`
  color: white !important;
  font-size: 18px !important;
  font-weight: 400 !important;
  margin: 0 !important;
  opacity: 0.9;
`;

const SubHeadingWithImage = styled.div`
  display: flex;
  flex-direction: "row";
  font-weight: 500;
  margin: 10px 0px 0px 0px;
  padding: 0px;

  h4 {
    margin-left: 10px;
  }
`;

const OverLayImageBackground: any = styled.div`
  background-color: #2e4a79;
  background-image: url(${(p: any) => p.banner});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 16px 16px 0px 0px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(78, 84, 200, 0.8),
      rgba(143, 148, 251, 0.8),
      rgba(46, 117, 182, 0.8)
    );
    border-radius: 16px 16px 0px 0px;
    z-index: 1;
  }
`;

export default JobCard;
